import React from "react";
import { MdArrowForward } from "react-icons/md";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import aidynamic from "./../Assets/Icons/aiDynamic.svg";
import bigfive from "./../Assets/Icons/bigFive.svg";

import { isEmpty } from "lodash";
import Tabs from "../Components/CommonCommponents/Tabs/Tabs";
import AssesmentReview from "./AssesmentReview";
import PendingAssessment from "./PendingAssesment";
import HireHubHeader from "./HireHubHeader";

export default function ViewAssessment() {
  const currentUser = JSON.parse(localStorage.getItem("candidate"));
  const tabsArray = [
    // {
    //   key: "pending assesment",
    //   tabName: "Pending Assesments",
    //   children: <PendingAssessment />,
    // },
    {
      key: "Report",
      tabName: "Assesment Review",
      children: <AssesmentReview />,
    },
  ].filter((item) => !isEmpty(item));

  const tabsItems = tabsArray.map((item) => {
    return {
      key: item.key,
      label: item.tabName,
      children: item.children,
    };
  });

  return (
    // <div className="min-h-screen bg-[#F5F7F9] w-full  flex  items-center pt-16 px-4 sm:px-6 lg:px-8">
    <div className="flex flex-col items-center w-full min-h-screen scrollbar-hide">
      <div className="flex items-center justify-end w-full lg:w-[72%]">
        {currentUser === null ? (
          <Link
            to="/login"
            className="border border-blue-500 text-sm md:text-base px-3 md:px-5 py-1.5 md:py-2 rounded-md hover:text-white hover:bg-[#0071DC] transition duration-300 text-center mr-5 md:mr-0"
          >
            Sign In
          </Link>
        ) : (
          <HireHubHeader />
        )}
      </div>
      <div className="flex justify-center w-full lg:w-[70%]">
        <div className="w-full">
          <Tabs
            items={tabsItems}
            className="w-full"
            // defaultActiveKey="pending assesment"
          />
        </div>
      </div>
    </div>
  );
}
